import React from 'react';
import { Section } from './ui/Section';
import { ShieldCheck, Clock, FileText, Gavel } from 'lucide-react';
export function WhyChooseUs() {
  const reasons = [{
    icon: ShieldCheck,
    title: 'Вузька спеціалізація',
    description: 'Ми займаємося виключно військовими справами, тому знаємо всі нюанси законодавства та судової практики.',
    number: '01'
  }, {
    icon: Clock,
    title: 'Оперативність 24/7',
    description: 'Розуміємо, що ситуації бувають невідкладними. Наші адвокати готові до термінових виїздів та консультацій.',
    number: '02'
  }, {
    icon: FileText,
    title: 'Прозорість роботи',
    description: 'Чесно оцінюємо перспективи справи. Фіксована вартість послуг без прихованих платежів.',
    number: '03'
  }, {
    icon: Gavel,
    title: 'Реальний досвід',
    description: 'Сотні успішних кейсів оскарження рішень ВЛК, незаконної мобілізації та отримання відстрочок.',
    number: '04'
  }];
  return <Section id="why-us" background="gray" data-id="element-206">
      <div className="mb-16 md:mb-24" data-id="element-207">
        <h2 className="text-3xl md:text-5xl font-bold text-black mb-6" data-id="element-208">
          Чому обирають нас
        </h2>
        <div className="h-px w-full bg-neutral-200" data-id="element-209"></div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-210">
        {reasons.map((reason, index) => <div key={index} className="group relative" data-id="element-211">
            {/* Number indicator */}
            <div className="absolute -top-4 -left-4 text-6xl font-bold text-neutral-100 group-hover:text-neutral-200 transition-colors pointer-events-none" data-id="element-212">
              {reason.number}
            </div>

            <div className="relative z-10" data-id="element-213">
              <div className="mb-6 group-hover:scale-110 transition-transform duration-300 origin-left" data-id="element-214">
                <reason.icon className="h-8 w-8 text-black stroke-[1.5]" data-id="element-215" />
              </div>
              <h3 className="text-xl font-bold text-black mb-4 group-hover:underline decoration-1 underline-offset-4 transition-all" data-id="element-216">
                {reason.title}
              </h3>
              <p className="text-neutral-500 leading-relaxed text-sm" data-id="element-217">
                {reason.description}
              </p>
            </div>

            {/* Decorative line */}
            <div className="absolute bottom-0 left-0 w-0 h-px bg-black group-hover:w-full transition-all duration-500" data-id="element-218"></div>
          </div>)}
      </div>
    </Section>;
}